package com.qrkontaq.data.repository

import com.qrkontaq.data.dto.PublicMenuDto
import com.qrkontaq.data.dto.PublicRestaurantDto
import com.qrkontaq.data.dto.PublicTableCheckDto
import com.qrkontaq.data.dto.ScanRequestDto
import com.qrkontaq.data.dto.ScanResponseDto
import com.qrkontaq.data.http.apiGet
import com.qrkontaq.data.http.apiPost
import io.ktor.client.HttpClient
import io.ktor.http.encodeURLPathPart

class PublicRepository(
    private val client: HttpClient,
) {
    suspend fun getRestaurant(slug: String): PublicRestaurantDto? =
        client.apiGet<PublicRestaurantDto>("v1/public/restaurants/$slug").data

    suspend fun getMenu(slug: String): PublicMenuDto? =
        client.apiGet<PublicMenuDto>("v1/public/restaurants/$slug/menu").data

    suspend fun recordScan(
        slug: String,
        tableLabel: String?,
        categorySlug: String?,
    ): ScanResponseDto? =
        client.apiPost<ScanResponseDto, ScanRequestDto>(
            "v1/public/restaurants/$slug/scan",
            ScanRequestDto(tableLabel = tableLabel, categorySlug = categorySlug),
        ).data

    /**
     * The live check for a table: the venue's still-open orders keyed by the QR
     * label. Public and unauthenticated so the diner's QR page can poll it while
     * the "check" sheet is open. Returns null on a network/parse error (the sheet
     * keeps the previously loaded value); an empty [PublicTableCheckDto] when the
     * waiter hasn't opened an order yet.
     */
    suspend fun tableCheck(
        slug: String,
        tableLabel: String,
    ): PublicTableCheckDto? =
        client.apiGet<PublicTableCheckDto>(
            "v1/public/restaurants/$slug/tables/${tableLabel.encodeURLPathPart()}/orders",
        ).data
}
